import { app } from "hyperapp";

import state from "./state";
import actions from "./actions";
import view from "./views/app";
import initMediaSession from "../player-media-session";

export default function player(el, props) {
  if (el.getAttribute("initialised") !== "true") {
    app({ ...state, ...props }, actions, view, el);
    initMediaSession();
  }
  el.setAttribute("initialised", "true");
}
